import { render, staticRenderFns } from "./UserProfileSubscribedUserProductsHistory.vue?vue&type=template&id=3551f5aa"
import script from "./UserProfileSubscribedUserProductsHistory.vue?vue&type=script&lang=js"
export * from "./UserProfileSubscribedUserProductsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports